import React from 'react';
import PropTypes from 'prop-types';

export default function SensorOverlay({ sensorData, currentTimestamp }) {
    if (!sensorData) {
        return null;
    }

    return (
        <div className="sensor-data-overlay">
            <div className="sensor-data-item">
                <i className="ri-temp-cold-line"></i>
                <span>{sensorData.temperature}°F</span>
            </div>
            <div className="sensor-data-item">
                <i className="ri-water-percent-line"></i>
                <span>{sensorData.humidity}%</span>
            </div>
            <div className="sensor-data-item">
                <i className="ri-sun-line"></i>
                <span>{sensorData.light} lux</span>
            </div>
            <div className="sensor-data-item">
                <i className="ri-contrast-drop-2-line"></i>
                <span>{sensorData.water}%</span>
            </div>
            {currentTimestamp && (
                <div className="sensor-data-timestamp">
                    <i className="ri-time-line"></i>
                    <span>{(() => {
                        try {
                            const date = new Date(currentTimestamp);
                            return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleTimeString();
                        } catch {
                            return 'Invalid Date';
                        }
                    })()}</span>
                </div>
            )}
        </div>
    );
}

SensorOverlay.propTypes = {
    sensorData: PropTypes.shape({
        temperature: PropTypes.number,
        humidity: PropTypes.number,
        light: PropTypes.number,
        water: PropTypes.number
    }),
    currentTimestamp: PropTypes.string
}; 